import { render, staticRenderFns } from "./naj-error-text.vue?vue&type=template&id=1e33fef9&scoped=true&"
import script from "./naj-error-text.vue?vue&type=script&lang=js&"
export * from "./naj-error-text.vue?vue&type=script&lang=js&"
import style0 from "./naj-error-text.vue?vue&type=style&index=0&id=1e33fef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e33fef9",
  null
  
)

export default component.exports